import React, { useRef, useEffect } from "react";
import styles from "./task-list-table.module.css";
import { columnsType, Task } from "../../types/public-types";
import dropDown from "../../../../svg/dropDown.svg";

export const TaskListTableDefault: React.FC<{
  rowHeight: number;
  rowWidth: string;
  fontFamily: string;
  fontSize: string;
  locale: string;
  tasks: Task[];
  selectedTask: Task | undefined;
  setSelectedTask: (taskId: string) => void;
  onExpanderClick: (task: Task) => void;
  taskSelect: (task: Task) => void;
  taskDblClick: ((task: Task) => void) | undefined;
  selectedTaskId: string;
  columns: columnsType[];
}> = ({
  rowHeight,
  rowWidth,
  tasks,
  fontFamily,
  fontSize,
  onExpanderClick,
  columns,
  taskSelect,
  taskDblClick,
  selectedTask,
}) => {
  const taskref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (selectedTask && taskref.current) {
      const selectedElement = taskref.current.querySelector(`[data-task-id="${selectedTask.id}"]`);
      if (selectedElement) {
        selectedElement.scrollIntoView({
          behavior: "instant", // or 'auto'
          block: "nearest", // or 'center', 'start', 'end'
          inline: "nearest", // prevent horizontal scrolling
        });
      }
    }
    
  }, [selectedTask]);
    
  return (
    <div
      className={styles.taskListWrapper + " w-full select-none "}
      style={{
        fontFamily: fontFamily,
        fontSize: fontSize,
      }}
      ref={taskref}
    >
      {tasks.map((t: any) => {
        let expanderSymbol: any;
        if (t.hideChildren === false) {
          expanderSymbol = (
            <img
              src={dropDown}
              className="w-5 min-w-5 rotate-180 font-semibold"
            />
          );
        } else if (t.hideChildren === true) {
          expanderSymbol = (
            <img src={dropDown} className="w-5 min-w-5 rotate-90" />
          );
        }
        return (
          <div
            onClick={() => taskSelect(t)}
            onDoubleClick={() => taskDblClick && taskDblClick(t)}
            className={
              "!border-b border-b-gray-300/50 cursor-pointer flex items-center " +
              (selectedTask && selectedTask.id === t.id ? "bg-primary-500/30" : "")
            }
            style={{ height: rowHeight }}
            data-task-id={t.id}
          >
            {columns.map((c, index) => {
              return (
                <div
                  onDoubleClick={() => taskDblClick && taskDblClick(t)}
                  className={styles.taskListCell + " last:w-full !overflow-visible"}
                  style={{
                    minWidth: c.width ? `${c.width}px` : rowWidth,
                    maxWidth: c.width ? `${c.width}px` : rowWidth,
                  }}
                  title={t.name}
                >
                  <div
                    className={
                      styles.taskListNameWrapper +
                      ` ${
                        t.subtask?.length ? "font-semibold " : "" + index
                      } text-[#787486cc]`
                    }
                    style={{
                      marginLeft: ` ${
                        index == 0 && t.level.split(".").length > 1
                          ? t.level.split(".").length * 12
                          : 0
                      }px`,
                    }}
                  >
                    {index === 0 && (
                      <div
                        className={
                          expanderSymbol
                            ? styles.taskListExpander
                            : styles.taskListEmptyExpander
                        }
                        onClick={() => {
                          onExpanderClick(t);
                        }}
                      >
                        {expanderSymbol}
                      </div>
                    )}

                    {c.render ? c.render(t) : `${t[c.field]}`}
                  </div>
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};
